import React from 'react';
import CompanyRequestCardConsult from './Company';

const RequestDuplicateCardConsult: React.FC = () => {
  return <CompanyRequestCardConsult />;
};

export default RequestDuplicateCardConsult;
